import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    target: String
  }

  // Inserts the sentence at the caret of the input we were opened for, wherever it lives: on the
  // page, or in the modal this one is stacked over.
  use(event) {
    if (!this.targetValue) return

    const sentense = document.getElementById(event.currentTarget.dataset.target).innerText
    const target = document.getElementById(this.targetValue)
    const [start, end] = [target.selectionStart, target.selectionEnd]

    target.setRangeText(sentense, start, end, 'end')
    target.dispatchEvent(new Event('input'))
    target.focus()
  }
}
